import { h, render } from 'preact'
import { Provider } from 'react-redux'

import './fonts/icomoon/index.css'
import './fonts/lato/index.css'
import initStore from './store/initStore'
import Main from './containers/Main'

const store = initStore()

export const init = ({ containerId, ...rest }) => {
  render((
    <Provider store={store}>
      <Main {...rest} />
    </Provider>
  ), document.getElementById(containerId))
}

export default init



// WEBPACK FOOTER //
// ./src/index.js